<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Empleados
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">

			<input type="radio" name="pcss3t" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(0)"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL">
				<i class="fa fa-users"></i>Empleados Activos
			</label>

			<input type="radio" [appCheckPermission]="[5047,5023]" [permissionType]="permissionType.ALL" name="pcss3t" (click)="updateIndexParam(1)"
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5047,5023]" [permissionType]="permissionType.ALL">
				<i class="fa fa-users-slash"></i>Empleados Inactivos
			</label>


		</div>
		<app-employee-active-list [hidden]="history!=0"></app-employee-active-list>
		<app-employee-inactive-list [hidden]="history!=1"></app-employee-inactive-list>
	</div>
</div>